import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Antd from 'ant-design-vue';
import i18n from "@/shared/lang";
import "./assets/css/index.less";
import "./guards";
import { VuePrint } from "@/plugins";
import VueBarcode from 'vue-barcode';
import VueQr from 'vue-qr';
import * as GmapVue from "gmap-vue";
import JsonExcel from "vue-json-excel";
import directive from "@/shared/directives/debounce";
import "./firebase-config";

Vue.config.productionTip = false;

Vue.use(Antd);
Vue.use(VuePrint);
Vue.component("barcode", VueBarcode);
Vue.component("qrcode", VueQr);
Vue.component("downloadExcel", JsonExcel);
Vue.directive("debounce", directive);

Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyCHddIuaZitAyZu4L7imJaxhG227YYdq_8',
    libraries: 'places',
    region: 'VI',
    language: 'vi',
    v: 3.38
  },
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
